module.exports = __webpack_public_path__ + "img/yanbaocool.dc223c54.svg";